<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0" class="padding10" :style="{ 'min-height': `${this.screenHeight - 160}px` }">
        <el-row>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">科别：{{ surgeryInfo.dic_section }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">姓名：{{ surgeryInfo.patient_name }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">性别：{{ surgeryInfo.sex || `--` }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">年龄：{{ surgeryInfo.age || `--` }}</label>
                <el-button style="float: right;margin-right: 10px !important;" type="primary" size="mini" @click="ReloadListData()" title="刷新当前页面">刷新</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">{{ T(`Saftycheck.visit_no`) }}：{{ surgeryInfo.visit_no || `--` }}</label>
            </el-col>
            <el-col :span="6" class="align-left">
                <label style="line-height: 35px">手术日期：{{ $moment(surgeryInfo.plan_time).format('YYYY/MM/DD') || `--` }}</label>
            </el-col>
            <el-col :span="12" class="align-left">
                <label style="line-height: 35px">{{surgeriesName}}{{ surgeryInfo.surgeries || `--` }}</label>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" class="align-right">
            <el-button type="primary" v-if="$root.DOCUMENT[`SaftCheck_001`] && unCheckedList.length == 0" @click.prevent="gotoDocument(surgeryInfo)">核查文书</el-button>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
            <el-col v-for="sc in SaftyCheckItem" :key="sc.saftycheck"  :lg="isdesktop == true ? 24 :SafetyCheckWidth  " :md="24" v-show="ShowCard(sc.saftycheck) == true">
                <div>
                    <el-card :body-style="{ padding: '5px', height: isdesktop == true ? `${screenHeight - 160}px` : `${screenHeight - 270}px` }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">{{sc.saftycheckname}}</h3></el-col>
                             <el-col :span="saftyCheckVoiceTimeOut>0?4:8" class="align-right padding20 padding-none-v">
                                <el-checkbox v-if="isShowSelectAllBtn" v-model="isSelectedAll[isSelectedKey + sc.saftycheck]" @change="selectedAll(sc.saftycheck)">全选</el-checkbox>
                            </el-col>
                             <el-col :span="4" class="align-right padding20 padding-none-v" v-if="saftyCheckVoiceTimeOut>0">
                              <el-button type="primary" icon="el-icon-microphone" size="mini" @click="speekVoice(sc.saftycheck)" ></el-button>
                            </el-col>
                        </el-row>
                        <div class="card-content" :style="{ 'overflow-y': 'auto', height: isdesktop == true ? `${screenHeight - 190}px` : `${screenHeight - 300}px` }">
                            <cus-form
                                :ref="`form-safty_${sc.saftycheck}`"
                                :key="`p_${sc.saftycheck}`"
                                :columns="getcolumns(sc.saftycheck)"
                                :data="AllDatas[`data_` + sc.saftycheck] || {}"
                                @imgclick="imgclick"
                                @imgdelete="imgdelete"
                                @extrabutton-click="ExtraButtonClick"
                                @confirm="saveP1"
                            >
                            </cus-form>
                            <!-- AllDatas[`data_` + sc.saftycheck] -->
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <el-dialog :title="`${title}签名`" :close-on-click-modal="false" :visible.sync="showDialogVisible" width="60%" @close="handleClose">
            <iframe ref="qrcode" :src="signUrl" allow="microphone;camera;canvas" v-show="showDialogVisible" class="docframe width-p100" seamless :style="{ height: '500px' }"></iframe>
        </el-dialog>
        <div v-if="msgDialogVisible" class="menu_box" :style="{ left: menuLeft + 'px', top: menuTop + 'px' }">
            <div class="menu">
                <div class="menu_item item_text" @click="deletemsg">删除</div>
                <div class="menu_item item_text" @click="msgDialogVisible = false">取消</div>
            </div>
        </div>
        <div class="speekmessage" :class="{ active: isHide }">
               <el-button style="float: right;" icon="el-icon-close" size="mini" @click="closeVoice()" ></el-button>

            <div class="note">{{speekmessage}}</div>
        </div>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SaftyCheckNew`,
    props: {},
    data() {
        window.addEventListener(
            `message`,
            event => {
                if (event.data.action == `ok`) {
                    this.showDialogVisible = false
                    this.CaSignBody(event.data)
                } else {
                    // this.showDialogVisible = false
                }
            },
            false
        )
        return {
            title: `安全核查`,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            token: this.$route.query.token,
            catoken: this.$route.query.catoken,
            permissions: [],
            isdesktop: false,
            toClose: true,
            currentList: [],
            showDialogVisible: false,
            useCa: this.$root.useCa,
            SaftyCheckUseCa: this.$root.SaftyCheckUseCa,
            caSignUrl: this.$root.CaSignUrl,
            caImagePath: this.$root.CaImagePath,
            saftyCheckReSign: this.$root.SaftyCheckReSign,
            saftyCheckVoiceMsg: this.$root.SaftyCheckVoiceMsg,
            saftyCheckVoiceTimeOut: this.$root.SaftyCheckVoiceTimeOut,
            isHide: true,
            query_enum_safty_check: this.$route.query.enum_safty_check,
            signUrl: ``,
            surgeryId: this.$route.query.surgery_id,
            surgeryInfo: {},
            surgeriesName: `拟施手术：`,
            SaftyCheckItem: [],
            SafetyCheckWidth: 24,
            unCheckedList: [],
            AllColumns: {},
            AllDatas: { },
            isShowSelectAllBtn: false, // 是否显示全选按钮
            isAlowEditCheckTime: false,
            isSelectedAll: {},
            AllCol: {},
            isSelectedKey: `AllSelect_P_`,
            selectAll: `security_check:selectAll`, // 全选权限
            msgDialogVisible: false,
            menuLeft: 0,
            menuTop: 0,
            speekmessage: ``,
            synth: null,
            saftyCheckRefreshTime: this.$root.SaftyCheckRefreshTime,
            msgsaftycheck: 0
        }
    },
    beforeDestroy() {
        clearInterval(this.refreshListData)
    },
    created() {
        let that = this
        clearInterval(this.refreshListData)
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_WORKBAR`)
        }
        if (this.catoken) {
            sessionStorage.setItem(`caToken`, this.catoken)
            this.$store.dispatch(`ADD_WORKBAR`)
        }
        this.$store.dispatch(`enums/ADD_ALL_ENUM`).then(() => {
            this.loadSaftyCheckItem()
        })
        let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
        req.then(permissions => {
            this.permissions = permissions

            this.isShowSelectAllBtn = _.find(permissions, { no: `security_check:selectAll` }) != undefined
            this.isAlowEditCheckTime = _.find(permissions, { no: `security_check:edit_checkTime` }) != undefined
            console.log(` this.isAlowEditCheckTime `, this.isAlowEditCheckTime)
        }).then(data => {
            this.loadSaftyCheckItem()
        })
        if (that.saftyCheckRefreshTime && that.saftyCheckRefreshTime > 0) {
            that.refreshListData = setInterval(() => {
                that.loadSaftyCheckItem()
            }, that.saftyCheckRefreshTime * 1000)
        }
    },
    mounted() {
        if (this.query_enum_safty_check != undefined && this.query_enum_safty_check != null) {
            this.isdesktop = true
        }
        this.synth = window.speechSynthesis
    },
    computed: {
        ...mapGetters([`currentUser`, `screenWidth`, `screenHeight`, `sys_enums`, `enum_menus`, `business`, `active_ward`])
    },
    methods: {
        ReloadListData() {
            this.loadSaftyCheckItem()
        },
        handleClose() {
            // 处理关闭事件
            this.signUrl = ``
            console.log(`Dialog closed`)
        },
        SetShowAllSelect() {

        },
        ShowCard(check) {
            if (this.query_enum_safty_check != undefined && this.query_enum_safty_check != null) {
                if (check == this.query_enum_safty_check) {
                    return true
                }
                return false
            } else {
                let index = check - 1
                if (this.unCheckedList && this.unCheckedList.indexOf(index) === -1) {
                    return true
                }
                return false
            }
        },
        loadSaftyCheckItem() {
            let that = this
            if (!this.surgeryId) return
            this.myaxios.get(`/api/AcisSystem/DicSaftyCheckItem/Get`).then(data => {
                // console.log(`data`, data)
                let saftychecks = []
                _.map(data, d => {
                    _.map(d.safty_check_stages, f => {
                        if (!saftychecks.includes(f)) {
                            saftychecks.push(f)
                        }
                    })
                })
                let objs = []
                saftychecks = saftychecks.sort((a, b) => a.display_order - b.display_order)
                _.map(saftychecks, saftycheck => {
                    let saftycheckname = ``
                    let saftycheckobj = this.sys_enums && this.sys_enums.SaftyCheckStage && this.sys_enums.SaftyCheckStage.find(f => f.value == saftycheck)
                    if (saftycheckobj) {
                        saftycheckname = saftycheckobj.label
                    }
                    let r = {
                        saftycheck: saftycheck,
                        saftycheckname: saftycheckname,
                        items: null
                    }
                    let find = data.filter(s => s.safty_check_stages.includes(saftycheck))

                    if (find) {
                        find = find.sort((a, b) => a.display_order - b.display_order)
                        r.items = find
                    }
                    this.$set(that.AllDatas, `data_` + saftycheck, {})
                    that.setcolumns(saftycheck, r)

                    objs.push(r)
                    this.isSelectedAll[this.isSelectedKey + saftycheck] = undefined
                    // this.AllDatas[`data_` + saftycheck] = undefined
                })
                if (objs && objs.length > 0) {
                    this.SafetyCheckWidth = 24 / objs.length
                }
                this.SaftyCheckItem = objs

                // console.log(`isSelectedAll`, this.isSelectedAll)
            }).then(inits => {
                // this.init()
                this.init()
            })
        },
        changeDefaultShow(enumsaftycheck) {
            let that = this
            let needColumns = _.filter(that.AllColumns[`data_` + enumsaftycheck], d => {
                return d.rel_keys && d.rel_keys != null && d.rel_keys.length > 0
            }) || []
            _.forEach(needColumns, c => {
                let changeKeys = []
                let changeOtherKeys = []
                let columnvalue = that.AllDatas[`data_` + enumsaftycheck][c.prop]
                if (columnvalue == null || columnvalue == ``) {
                    columnvalue = c.default
                }
                _.forEach(c.rel_keys, k => {
                    let ak = k.DataKeys && k.DataKeys.split(`,`) || []
                    if (k.value == columnvalue) {
                        changeKeys = [...changeKeys, ...ak]
                    } else {
                        changeOtherKeys = [...changeOtherKeys, ...ak]
                    }
                })
                if (changeOtherKeys) {
                    _.forEach(changeOtherKeys, ckey => {
                        let k = that.AllColumns[`data_` + enumsaftycheck].find(s => s.prop == ckey)
                        if (k) {
                            k.isShow = false
                            that.$set(that.AllDatas[`data_` + enumsaftycheck], ckey, undefined)
                        }
                    })
                }
                if (changeKeys) {
                    _.forEach(changeKeys, ckey => {
                        let cvalue = that.AllDatas[`data_` + enumsaftycheck][ckey]
                        let k = that.AllColumns[`data_` + enumsaftycheck].find(s => s.prop == ckey)
                        if (k) {
                            k.isShow = true
                            that.$set(that.AllDatas[`data_` + enumsaftycheck], ckey, cvalue)
                        }
                    })
                }
            })
        },
        init() {
            let that = this
            // 获取当前手术信息
            let req = this.myaxios.get(`/api/Operation/Home/Get?id=${this.surgeryId}`)
            let req1 = this.myaxios.get(`/api/Intraoperative/SaftyCheck/Records?surgeryInfoId=${this.surgeryId}`)
            let req2 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/OccuredEvents?surgeryInfoId=${this.surgeryId}&recordType=1`)
            // 获取局麻事件列表
            let req3 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/PartAnesEvents?surgeryInfoId=${this.surgeryId}&recordType=1`)
            this.myaxios.all(req, req1, req2, req3).then(([data, data1, data2, data3]) => {
                let events = data2.length == 0 ? data3 : data2
                // 患者基本信息
                this.surgeryInfo = data
                if (this.surgeryInfo.enum_surgery_status >= 30) {
                    this.surgeriesName = `实施手术：`
                } else {
                    this.surgeriesName = `拟施手术：`
                }
                console.log(`this.surgeryInfo`, this.surgeryInfo)
                let passData = _.filter(data1, { is_pass: true })
                _.reduce(
                    data1,
                    function(items, item, key) {
                        // 麻前检查时间获取进手术间时间
                        let startTime = item && item.start_time || (_.filter(events, { event_name: `进手术间` })[0] && _.filter(events, { event_name: `进手术间` })[0].occur_time)
                        let occurTime = item && item.check_date
                        let obj = {
                            id: item.id || 0,
                            biz_surgery_info_id: that.surgeryId,
                            enum_safty_check: item.enum_safty_check,
                            is_pass: item.is_pass,
                            check_date: item.check_date,
                            start_time: item.start_time,
                            safty_check_items: []
                        }
                        _.reduce(
                            item.safty_check_items,
                            function(result, value, key) {
                                // result[value.check_name] = value.check_value
                                if (value.check_name != `doctor_name` && value.check_name != `anesthesia_name` && value.check_name != `nurse_name` && value.check_name != `start_time` && value.check_name != `occur_time`) {
                                    obj[value.check_name] = value.check_value
                                }
                            },
                            {}
                        )
                        that.AllDatas[`data_` + item.enum_safty_check] = obj
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`doctor_name`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`doctor_name`] = { value: item.surgeon, label: item.surgeon_name }
                        }
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`anesthesia_name`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`anesthesia_name`] = { value: item.anesthesiologist, label: item.anesthesiologist_name }
                        }
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`nurse_name`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`nurse_name`] = { value: item.circuit_nurse, label: item.circuit_nurse_name }
                        }
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`start_time`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`start_time`] = (startTime && that.$moment(startTime).format(`YYYY-MM-DD HH:mm`)) || that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                        }
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`occur_time`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`occur_time`] = (occurTime && that.$moment(occurTime).format(`YYYY-MM-DD HH:mm`)) || that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                        }
                        that.changeDefaultShow(item.enum_safty_check)
                    },
                    {}
                )
                // 获取当前核查阶段
                let stage = _.map(passData, d => {
                    return d.enum_safty_check
                })
                // 判断是否还有未核查的
                let r = _.filter(this.sys_enums.SaftyCheckStage, d => {
                    return stage.indexOf(d.value) === -1
                })

                if (r.length !== 0) {
                    this.currentList = {
                        id: r[0].value,
                        label: r[0].label
                    }
                } else {
                    this.currentList = {
                        id: this.sys_enums.SaftyCheckStage[stage.length - 1].value,
                        label: this.sys_enums.SaftyCheckStage[stage.length - 1].value.label
                    }
                }

                console.log(`currentList`, this.currentList)
                // 未核查记录
                this.unCheckedList = _.map(r, d => {
                    return d.value
                })
                // 赋值enum_safty_check到data里面
                // if (!that.AllDatas[`data_` + that.currentList.id][`enum_safty_check`]) {
                //     // that.AllDatas[`data_` + that.currentList.id][`enum_safty_check`] = that.currentList.id
                //     this.$set(that.AllDatas[`data_` + that.currentList.id], `enum_safty_check`, that.currentList.id)
                // }
                if (!this.isCaSign() && r.length !== 0) {
                    // ACIS-23527 已记录保存手术医生、巡回护士、麻醉医生情况下，各节点安全核查自动提取带出
                    if (!that.AllDatas[`data_` + that.currentList.id][`doctor_name`]) {
                        that.AllDatas[`data_` + that.currentList.id][`doctor_name`] = data.plan_surgeon_doctor
                    }
                    if (!that.AllDatas[`data_` + that.currentList.id][`anesthesia_name`]) {
                        that.AllDatas[`data_` + that.currentList.id][`anesthesia_name`] = data.plan_anes_doctor
                    }
                    if (!that.AllDatas[`data_` + that.currentList.id][`nurse_name`] && data.plan_circuit_nurse && data.plan_circuit_nurse.length > 0) {
                        that.AllDatas[`data_` + that.currentList.id][`nurse_name`] = data.plan_circuit_nurse[0]
                    }
                }
            })
        },
        changeimgstatus(saftycheck) {
            this.$set(this.AllDatas[`data_` + saftycheck], `enum_safty_check`, `0`)
            this.$set(this.AllDatas[`data_` + saftycheck], `enum_safty_check`, saftycheck)
        },
        speekVoice(saftycheck) {
            this.$nextTick(() => {
                // 获取当前阶段的字段
                let columns = this.getcolumns(saftycheck)
                let arr = []
                let chs = _.cloneDeep(this.SaftyCheckItem)
                let t2 = chs.find(s => s.saftycheck == saftycheck)
                let saftycheckname = t2.saftycheckname
                let saftyCheckVoiceobj = JSON.parse(this.saftyCheckVoiceMsg || ``)
                arr.push(saftyCheckVoiceobj.Begin.replace(`{titleName}`, saftycheckname))
                columns.map(d => {
                    if (d.type == `checkboxgroup`) {
                        d.options.map(f => {
                            arr.push(f.label)
                        })
                    } else if (d.prop != `start_time` && d.prop != `occur_time` && d.prop != `doctor_name` && d.prop != `anesthesia_name` && d.prop != `nurse_name` && d.prop != `oper`) {
                        arr.push(d.label.content)
                    }
                })
                arr.push(saftyCheckVoiceobj.End.replace(`{titleName}`, saftycheckname))
                console.log(arr)
                this.speakList(arr)
            })
        },
        closeVoice() {
            let that = this
            that.isHide = true
            if (that.synth.speaking) {
                that.synth.cancel()
            }
        },
        speakList(arr) {
            let that = this
            that.isHide = false
            if (that.synth.speaking) {
                that.synth.cancel()
            }
            that.speekmessage = ``
            arr.forEach((message, index) => {
                setTimeout(function() {
                    let utterance = new SpeechSynthesisUtterance()
                    utterance.text = message
                    utterance.lang = `zh-CN` // 设置语言为中文
                    utterance.volume = 1 // 音量：0 到 1
                    utterance.rate = 1 // 语速：0.1 到 10
                    utterance.pitch = 2 // 音调：0 到 2
                    utterance.onstart = () => {
                        that.speekmessage = message
                    }
                    utterance.onerror = (event) => {
                        console.error(`语音合成出现错误:`, event.error)
                    }
                    utterance.onend = () => {
                        if (!that.synth.speaking) {
                            that.isHide = true
                        }
                    }
                    console.log(that.speekmessage)
                    that.synth.speak(utterance)
                }, that.saftyCheckVoiceTimeOut)
            })
        },
        gotoDocument(surgery) {
            console.log(this.business)
            let menuName = `document2`
            let r = _.find(this.business, t => {
                return t.business_level == `M004` && t.location == menuName
            })
            if (!r) {
                this.$message.error(`患者管理没有配置 ${menuName} 页面,请配置菜单和工作栏`)
            } else {
                let menuInfo = _.cloneDeep(r)
                let rurl = menuInfo.url
                if (rurl) {
                    let docId = this.$root.DOCUMENT[`SaftCheck_001`]
                    rurl += rurl.indexOf(`?`) > -1 ? `&` : `?`
                    rurl = `${rurl}&docId=${docId}&isOnly=1`
                    menuInfo.url = rurl
                    this.openUrl(menuInfo, surgery)
                } else {
                    console.log(`菜单`, menuInfo)
                    this.$message.error(`请检查患者文书菜单配置`)
                }
            }
        },
        openUrl(menuInfo, surgery) {
            console.log(menuInfo)
            let url = (menuInfo && menuInfo.url) || `/`
            // 第三方链接直接弹框打开，不用二次弹框打开
            // 本系统页面链接，直接调用患者管理路由加载界面
            url += url.indexOf(`?`) > -1 ? `&` : `?`
            url = `${url}surgery_id=${surgery.id}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
            let routeUrl = this.$router.resolve({
                path: url
            })
            var w = this.screenWidth - 10
            var h = this.screenHeight - 10
            window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
        },
        selectedAll(saftycheck) {
            let that = this

            let checkboxs = this.AllColumns[`data_` + saftycheck].filter(d => {
                return d.type == `checkboxgroup`
            })
            if (this.isSelectedAll[this.isSelectedKey + saftycheck]) {
                _.map(checkboxs, checkbox => {
                    let options = checkbox.options.map(d => {
                        return d.value
                    })
                    this.$set(that.AllDatas[`data_` + saftycheck], checkbox.prop, options.join(`,`))
                })
                console.log(that.AllDatas[`data_` + saftycheck])
            } else {
                _.map(checkboxs, checkbox => {
                    that.AllDatas[`data_` + saftycheck][checkbox.prop] = ``
                })
                console.log(that.AllDatas[`data_` + saftycheck])
            }
        },
        checkedThrough(row) {
            let { formdata } = row
            this.saveData(formdata, true)
        },

        checkedReject(row) {
            let { formdata } = row
            this.saveData(formdata, false)
        },
        saveData(formdata, ispass) {
            let that = this
            let lists = this.getSaftyCheckItems(formdata)
            let checkstring = this.getCheckSaftyCheckItems(formdata)
            let saftycheck = formdata.origion.enum_safty_check
            let data = {
                id: formdata.origion.id || 0,
                biz_surgery_info_id: this.surgeryId,
                enum_safty_check: saftycheck,
                is_pass: ispass,
                check_date: formdata.occur_time,
                start_time: formdata.start_time,
                safty_check_items: lists
            }
            let datacheck = {
                biz_surgery_info_id: this.surgeryId,
                enum_safty_check: saftycheck,
                checkstring: checkstring
            }

            if (this.isCaSign() == true) {
                if (ispass) {
                    let surgeon = that.AllDatas[`data_${saftycheck}`][`doctor_name`]
                    let anesthesiologist = that.AllDatas[`data_${saftycheck}`][`anesthesia_name`]
                    let circuitnurse = that.AllDatas[`data_${saftycheck}`][`nurse_name`]

                    data.surgeon = surgeon && surgeon.value || undefined
                    data.surgeon_name = surgeon && surgeon.label || undefined
                    data.anesthesiologist = anesthesiologist && anesthesiologist.value || undefined
                    data.anesthesiologist_name = anesthesiologist && anesthesiologist.label || undefined
                    data.circuit_nurse = circuitnurse && circuitnurse.value || undefined
                    data.circuit_nurse_name = circuitnurse && circuitnurse.label || undefined
                } else {
                    data.surgeon = undefined
                    data.surgeon_name = `核查未通过`
                    data.anesthesiologist = undefined
                    data.anesthesiologist_name = `核查未通过`
                    data.circuit_nurse = undefined
                    data.circuit_nurse_name = `核查未通过`
                }
            } else {
                data.surgeon = (formdata[`doctor_name`] && formdata[`doctor_name`].value) || undefined
                data.anesthesiologist = (formdata[`anesthesia_name`] && formdata[`anesthesia_name`].value) || undefined
                data.circuit_nurse = (formdata[`nurse_name`] && formdata[`nurse_name`].value) || undefined
                data.surgeon_name = (formdata[`doctor_name`] && formdata[`doctor_name`].label) || undefined
                data.anesthesiologist_name = (formdata[`anesthesia_name`] && formdata[`anesthesia_name`].label) || undefined
                data.circuit_nurse_name = (formdata[`nurse_name`] && formdata[`nurse_name`].label) || undefined
            }
            // 判断空条件
            if (data.surgeon === undefined || data.surgeon_name === undefined) {
                this.$message.warning(`手术医生确认不能为空`)
                return
            }
            // 局麻手术 有些情况会没有麻醉医生，不用判断麻醉医生必填
            if (!that.surgeryInfo.is_local_anes && (data.anesthesiologist === undefined || data.anesthesiologist_name === undefined)) {
                this.$message.warning(`麻醉医生确认不能为空`)
                return
            }
            if (data.circuit_nurse === undefined || data.circuit_nurse_name === undefined) {
                this.$message.warning(`巡回护士确认不能为空`)
                return
            }
            console.log(this.SaftyCheckItem)
            let chs = _.cloneDeep(this.SaftyCheckItem)
            let t2 = chs.find(s => s.saftycheck == saftycheck)
            let sussmessage = ``
            if (t2 != null) {
                sussmessage = t2.saftycheckname
            }
            that.myaxios.post(`/api/Intraoperative/SaftyCheck/checkPost`, datacheck).then(checkdata => {
                let req = that.myaxios.post(`/api/Intraoperative/SaftyCheck/Records`, data)
                req.then(data => {
                    if (ispass) {
                        this.$message.success(sussmessage + `保存成功`)
                    } else {
                        this.$message.warning(sussmessage + `核对不通过`)
                    }
                    // 系统文书配置了安全核查对应文书后就弹框显示
                    if (that.$root.DOCUMENT[`SaftCheck_001`] && saftycheck == that.unCheckedList[that.unCheckedList.length - 1]) {
                        that.gotoDocument(that.surgeryInfo)
                        that.toClose = false // 不自动关闭，弹文书窗口 在 destop 窗体 如果自动关闭会有问题，同时把文书的窗体也关了
                    }
                    that.init()
                    that.sendMessage()
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        sendMessage() {
            if (this.isdesktop && this.toClose) {
                // destop 窗体 核查 自动关闭，如果有弹文书窗口的话 就需要手动关闭一下
                let r = typeof winformMsg
                if (r != `undefined`) {
                    var cefJson = {
                        data: {},
                        action: `closeWindow`
                    }
                    winformMsg.acceptMessage(cefJson)
                }
            }
        },
        getSaftyCheckItems(row) {
            let that = this
            console.log(`row`, row)
            let lists = _.reduce(
                row,
                function(result, value, key) {
                    let type = typeof value
                    if (value !== undefined && value !== null && key !== `origion` && !_.endsWith(key, `doctor_name`) && !_.endsWith(key, `anesthesia_name`) && !_.endsWith(key, `nurse_name`)) {
                        result.push({
                            id: 0,
                            biz_safty_check_id: that.currentList.id,
                            check_name: key,
                            check_value: type === `object` ? value.toString() : value
                        })
                    }
                    return result
                },
                []
            )
            return lists
        },
        getCheckSaftyCheckItems(row) {
            let that = this
            let r = _.reduce(
                row,
                function(result, value, key) {
                    let type = typeof value
                    let valuestr = ``
                    if (value !== undefined && value !== null && key !== `origion` && !_.endsWith(key, `doctor_name`) && !_.endsWith(key, `anesthesia_name`) && !_.endsWith(key, `nurse_name`)) {
                        if (type === `object`) {
                            valuestr = value.toString()
                        } else {
                            if (key == `occur_time` || key == `start_time`) {
                                valuestr = that.$moment(value).format(`YYYY/MM/DD HH:mm`)
                            } else {
                                valuestr = value
                            }
                        }
                        result += (key + `=` + valuestr + `&`)
                    }
                    return result
                },
                []
            )
            // 去除末尾的@
            if (r != null && r.length > 0) {
                r = r.replace(/&$/, ``)
            }

            return r
        },
        imgdelete(e) {
            let that = this
            let saftycheck = e.formdata.origion.enum_safty_check || e.formdata.origion.defaultsafecheck
            let info = that.AllDatas[`data_${saftycheck}`][e.column.prop]
            if (info && info.trim() != ``) {
                that.menuLeft = e && e.event && e.event.clientX || 0
                that.menuTop = e && e.event && e.event.clientY || 0
                that.msgsaftycheck = saftycheck
                that.msgporp = e.column.prop
                that.msgDialogVisible = true
            }
        },
        deletemsg() {
            let that = this
            if (that.AllDatas[`data_${that.msgsaftycheck}`] && that.AllDatas[`data_${that.msgsaftycheck}`][that.msgporp]) {
                that.AllDatas[`data_${that.msgsaftycheck}`][that.msgporp] = undefined
                if (that.msgporp.indexOf(`doctor_name`) > -1) {
                    that.AllDatas[`data_${that.msgsaftycheck}`][`doctor_name`] = undefined
                } else if (that.msgporp.indexOf(`anesthesia_name`) > -1) {
                    that.AllDatas[`data_${that.msgsaftycheck}`][`anesthesia_name`] = undefined
                } else if (that.msgporp.indexOf(`nurse_name`) > -1) {
                    that.AllDatas[`data_${that.msgsaftycheck}`][`anesthesia_name`] = undefined
                }
                this.changeimgstatus(that.msgsaftycheck)
            }
            that.msgDialogVisible = false
        },
        ExtraButtonClick(target) {
            this[target.emit](target)
        },
        saveP1(row) {
            console.log(row)
        },
        imgclick(e) {
            this.DoCaSign(e)
        },
        DoCaSign(e) {
            // this.$set(this.AllDatas[`data_1`], `doctor_name_sign`, `http://10.100.10.206:9713/templates/images/zx001.png`)
            console.log(e.formdata)
            let datas = this.getSaftyCheckItems(e.formdata)
            let r = JSON.stringify(datas)
            console.log(r)
            console.log(`11111`, e.formdata.origion)
            console.log(`2222`, this.SaftyCheckItem)
            console.log(`3333`, e)
            let url = `${this.caSignUrl}?app_key=${this.$root.appKey}&ca_token=`
            let caToken = sessionStorage.getItem(`caToken`)
            if (caToken) url = `${url}${caToken}`
            var random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            let rcode = ``
            for (var i = 0; i < 8; i++) {
                // 设置随机数范围,这设置为0 ~ 36
                var index = Math.floor(Math.random() * 9)
                // 字符串拼接 将每次随机的字符 进行拼接
                rcode += random[index]
            }
            var t = this.SaftyCheckItem.find(s => s.saftycheck == e.formdata.origion.enum_safty_check)
            var bizid = this.surgeryId + `|` + (e.formdata.origion.enum_safty_check) + `|` + e.column.prop + `|` + t.saftycheckname + e.column.label.content + `|` + rcode
            this.myaxios.post(url, {
                user_agent: `chrome`,
                timestamp: new Date().getTime(),
                data: {
                    biz_id: bizid,
                    raw_data: r
                }
            }).then((signUrl) => {
                console.log(signUrl)
                this.signUrl = signUrl + `&type=${e.column.prop}`
                this.showDialogVisible = true
            })
        },
        CaSignBody(data) {
            let that = this
            let bizdata = data.data
            let req = that.myaxios.get(`/api/AcisSystem/Authorization/GetAcUserByUserCode?username=${bizdata.username}`)
            req.then(user => {
                let bizs = bizdata.biz_id.split(`|`)
                if (bizs.length >= 1) {
                    let enumsaftycheck = bizs[1]
                    let proname = bizs[2]
                    this.$set(that.AllDatas[`data_` + enumsaftycheck], proname, `${this.caImagePath}/${bizdata.username}.png`)
                    // if (b.data_key == `doctor_name` || b.data_key == `anesthesia_name` || b.data_key == `nurse_name`)
                    if (proname.indexOf(`doctor_name`) > -1) {
                        this.$set(that.AllDatas[`data_` + enumsaftycheck], `doctor_name`, { label: user.dic_worker_name, value: user.dic_worker_id })
                    } else if (proname.indexOf(`anesthesia_name`) > -1) {
                        this.$set(that.AllDatas[`data_` + enumsaftycheck], `anesthesia_name`, { label: user.dic_worker_name, value: user.dic_worker_id })
                    } else if (proname.indexOf(`nurse_name`) > -1) {
                        this.$set(that.AllDatas[`data_` + enumsaftycheck], `nurse_name`, { label: user.dic_worker_name, value: user.dic_worker_id })
                    }
                    console.log(`CaSignBody`, that.AllDatas)
                    this.changeimgstatus(enumsaftycheck)
                    // 这里更改一下这个参数，用来触发一下create,不然图片会不刷新
                    // that.SaftyCheckUseCa = 0
                    // that.SaftyCheckUseCa = 1
                }
            })
        },
        checkSaftyCheckReSign(row, num) {
            let that = this
            console.log(`row`, row)
            return new Promise((resolve, reject) => {
                if (that.saftyCheckReSign && that.saftyCheckReSign.trim() == `1` &&
                        ((row[`doctor_name_sign`] && row[`doctor_name_sign`].trim() != ``) ||
                                (row[`anesthesia_name_sign`] && row[`anesthesia_name_sign`].trim() != ``) != null ||
                                (row[`nurse_name_sign`] && row[`nurse_name_sign`].trim() != ``) != null)
                ) {
                    that.$alert(`用户数据修改需要重新签名`, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    }).then(data => {
                        row[`doctor_name_sign`] = undefined
                        row[`anesthesia_name_sign`] = undefined
                        row[`nurse_name_sign`] = undefined
                        row[`doctor_name`] = undefined
                        row[`anesthesia_name`] = undefined
                        row[`nurse_name`] = undefined

                        that.AllDatas[`data_${num}`][`doctor_name_sign`] = undefined
                        that.AllDatas[`data_${num}`][`anesthesia_name_sign`] = undefined
                        that.AllDatas[`data_${num}`][`nurse_name_sign`] = undefined
                        that.AllDatas[`data_${num}`][`doctor_name`] = undefined
                        that.AllDatas[`data_${num}`][`anesthesia_name`] = undefined
                        that.AllDatas[`data_${num}`][`nurse_name`] = undefined

                        resolve(row)
                    }).catch(e => {
                        console.log(e)
                        resolve(row)
                    })
                }
                resolve(row)
            })
        },
        changeShow(cm, row, saftycheck) {
            let that = this
            return new Promise((resolve, reject) => {
                let value = row[`${cm.prop}`]
                let changeKeys = []
                let changeOtherKeys = []
                _.forEach(cm.rel_keys, k => {
                    let ak = k.DataKeys && k.DataKeys.split(`,`) || []
                    if (k.value == value) {
                        changeKeys = [...changeKeys, ...ak]
                    } else {
                        changeOtherKeys = [...changeOtherKeys, ...ak]
                    }
                })
                that.AllColumns[`data_` + saftycheck] = that.AllColumns[`data_` + saftycheck].map(d => {
                    if (changeOtherKeys.includes(d.prop)) {
                        d.isShow = false
                        row[`${d.prop}`] = undefined
                        that.$set(that.AllDatas[`data_` + saftycheck], d.prop, undefined)
                    }
                    if (changeKeys.includes(d.prop)) {
                        d.isShow = true
                        row[`${d.prop}`] = d.default
                        that.$set(that.AllDatas[`data_` + saftycheck], d.prop, d.default)
                    }
                    return d
                })
                that.$forceUpdate()
                resolve(row)
            })
        },
        setcolumns(saftycheck, obj) {
            // prop生成规则   safty_{saftycheck}_{data_key}
            let that = this
            let columns = []
            let saftyCheckmodel = _.cloneDeep(obj)
            if (saftyCheckmodel.items && saftyCheckmodel.items.length > 0) {
                let items = saftyCheckmodel.items.sort((a, b) => a.display_order - b.display_order)
                let allKeys = _.filter(items, d => {
                    return d.is_show == true && d.rel_keys != null && d.rel_keys != `` && d.default_value != null
                }) || []
                let keys = []
                _.forEach(allKeys, k => {
                    let relKeys = eval(
                        `(` + k.rel_keys + `)`
                    )
                    let item = _.find(relKeys, x => x.value == k.default_value)
                    let okeys = item && item.DataKeys && item.DataKeys.split(`,`) || []
                    keys = [...keys, ...okeys]
                })
                _.forEach(items, b => {
                    let cm = {
                        type: b.data_type,
                        prop: b.data_key,
                        options: (b.data_type == `select` || b.data_type == `checkboxgroup` || b.data_type == `radio`) ? JSON.parse(b.data_option) : null,
                        label: { content: `${b.name || ` `}`, position: `${b.position}` },
                        colspan: b.data_colspan,
                        area: [1, 2],
                        readonly: b.data_read_only,
                        default: b.default_value,
                        isShow: keys.includes(b.data_key) || b.is_show,
                        dafaultShow: b.is_show,
                        rel_keys: b.rel_keys && eval(
                            `(` + b.rel_keys + `)`
                        ) || []
                    }
                    cm.change = (ddd, { row, index }) => {
                        that.changeShow(cm, row, saftycheck)
                        row = that.checkSaftyCheckReSign(row, saftycheck)
                    }
                    if (b.data_required == true) {
                        cm.validate = [{ required: true, message: `必填项目`, trigger: `blur` }]
                    }
                    // 初始化好，data结构，防止页面不重新渲染
                    this.$set(that.AllDatas[`data_` + saftycheck], b.data_key, undefined)
                    if (b.data_key == `start_time` || b.data_key == `occur_time`) {
                        if (this.isAlowEditCheckTime) {
                            cm.readonly = false
                        } else {
                            cm.readonly = true
                        }
                    }

                    if (b.data_type == `remoteselect` || b.data_type == `remotemultiselect` || b.data_type == `remoteselecttable`) {
                        cm.options = (that2, { row }) => {
                            return q => {
                                let r = that.myaxios.get(`/api/AcisSystem/SurgeryInfoExtraParam/SearchOptionsByKey?sql=${b.data_option}`, q)
                                return r
                            }
                        }
                        if (b.data_key == `doctor_name` || b.data_key == `anesthesia_name` || b.data_key == `nurse_name`) {
                            cm.change = null
                            if (!this.isCaSign()) {
                                cm.options = (that2, { row }) => {
                                    return q => {
                                        let r = that.myaxios.get(`/api/AcisSystem/SurgeryInfoExtraParam/SearchOptionsIntByKey?sql=${b.data_option}`, q)
                                        return r
                                    }
                                }
                            } else {
                                // 重新生成prop
                                cm.prop = b.data_key + `_sign`
                                cm.type = `img`

                                this.$set(that.AllDatas[`data_` + saftycheck], cm.prop, undefined)
                            }
                        }
                    }
                    columns.push(cm)
                })
            }

            columns.push(
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    isShow: true,
                    label: { content: ` `, position: `top` },
                    options: (that, { row }) => {
                        if (row.origion.is_pass) {
                            return [
                                {
                                    label: `保存`,
                                    type: `primary`,
                                    emit: `checkedThrough`,
                                    permission: `default`
                                }
                            ]
                        }
                        return [
                            {
                                label: `核对通过`,
                                type: `primary`,
                                emit: `checkedThrough`,
                                permission: `default`
                            },
                            {
                                label: `核对不通过`,
                                type: `default`,
                                emit: `checkedReject`,
                                permission: `default`
                            }
                        ]
                    },
                    colspan: 24,
                    config: {
                        align: `start`
                    }
                })
            // 给data增加enum_safty_check，后续会用到
            this.$set(that.AllDatas[`data_` + saftycheck], `enum_safty_check`, saftycheck)
            this.AllColumns[`data_` + saftycheck] = columns
            console.log(`data_`, this.AllColumns[`data_` + saftycheck])
        },
        getcolumns(saftycheck) {
            let result = this.AllColumns && this.AllColumns[`data_` + saftycheck] || []
            return result.filter(item => item.isShow)
        },
        isCaSign() {
            if (this.useCa == `1` && this.SaftyCheckUseCa == `1`) {
                return true
            }
            return false
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadSaftyCheckItem()
        }
    },
    destroyed() {
        let that = this
        that.isHide = false
        if (that.synth.speaking) {
            that.synth.cancel()
        }
    }
}
</script>
<style scoped>
#div1 {
    position: relative;
}
#div2 {
    position: relative;
    left: 20px;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
h3 {
    margin: 0;
}

.card-content /deep/ .safecheck_p3_gzgl .el-form-item__content div label:nth-last-child(1) {
    display: block;
}

.card-content /deep/ .safecheck_p3_gzgl .el-form-item__label {
    width: 100%;
    display: flex;
}

.card-content /deep/ .el-form-item__content {
    line-height: 35px !important;
}

.card-content /deep/ .safecheck_p3_gzgl_qt_text {
    width: 120px;
    position: absolute;
}

/* position: relative;
    right: -220px;
    top: -52px; */

.card-content /deep/ .safecheck_p3_gzgl_qt_text .el-form-item__content {
    margin-left: 10px !important;
    position: relative;
    top: -46px;
    left: 80px;
}
.speekmessage {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 200px;
    color: #ffffff;
    background-image: linear-gradient(#ee0262, #650133);
    z-index: 999;
    border-radius: 10px;
    margin-top: -100px;
    margin-left: -400px;
    font-size: 48px;
}
.note {
    height: 50%;
    line-height: 200px;
}
.active {
    display: none;
}
</style>
<style  lang="less">
.handover-nurse .el-timeline-item__node {
    cursor: pointer;
    z-index: 2;
    &:hover {
        width: 20px;
        height: 20px;
        left: -6px;
        top: -6px;
        background: #409eff;
    }
}
// .safecheck_p1_gms  {
//   label.el-form-item__label{
//     color:red !important;
//   }
// }
.menu_box {
    position: fixed;
    z-index: 1004;
    background-color: #fff;
    // border-radius: 5px;
    .menu {
        width: 100px;
        text-align: left;
        // padding: 5px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .menu_item {
            height: 24px;
            line-height: 22px;
            // margin-top: 5px;
        }
        .item_text {
            color: #171a1d;
            cursor: pointer;
            padding: 4px 20px;
            // border-radius: 3px;
            transition: all 0.2s ease-in;
        }
        .item_text:hover {
            background-color: #e9eaec;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/SaftyCheck/SaftyCheckNew.vue